module.exports = __webpack_public_path__ + "static/media/Computer_ventilator.df21bba7.mp3";